$(document).ready(function() {
  $(".js-newsletter-subscribe-form .js-newsletter-subscribe-over18").change(
    function() {
      var form = $(this).closest("form");
      var btn = $(form).find(".js-newsletter-subscribe-submit-button");
      if (this.checked) {
        btn.prop("disabled", "");
      } else {
        btn.prop("disabled", "disabled");
      }
    }
  );

  $(
    ".js-newsletter-subscribe-form .js-select-newsletters input[type='checkbox']"
  ).change(function() {
    var checkboxes = $('.js-select-newsletters input[type="checkbox"]');
    if (checkboxes.is(":checked")) {
      checkboxes.removeClass("is-invalid");
    } else {
      checkboxes.addClass("is-invalid");
    }
  });

  $(".js-newsletter-subscribe-submit-button").click(function(e) {
    e.preventDefault();

    var form = $(this).closest("form");
    var validator = $.validator;
    if (!validator || form.valid()) {
      if ($(".js-select-newsletters").length) {
        var checkboxes = $('.js-select-newsletters input[type="checkbox"]');
        if (checkboxes.is(":checked") === false) {
          checkboxes.addClass("is-invalid");
          return false;
        }
      }

      var btn = $(this);
      btn.prop("disabled", "disabled");
      btn.text("Subscribing...");
      form.submit();
    }
  });

  $("div.modal.js-serverValidation-openModal").modal("show");
});
